export default {
    pluginName: 'clinical_result',
    backendDataType: 'CLINICAL_TRIAL_RESULT',
    rowIdKey: 'CLINICAL_RESULT_ID',
    edit: 'data_edit',
    count: 'clinical_trial_result_count',
    totalCount: 'total_clinical_trial_result_count',
    fieldI18nKey: 'commonClinicalResult',
    maxPerFolder: 'max_clinical_result_per_folder',
    maxOp: 'max_op_clinical_result',
    staticFields: [],
    dataId: 'CLINICAL_RESULT_ID',
};
